module.exports = __webpack_public_path__ + "img/avatar3.22cfc472.png";